// services/api.js
import axios from "axios";

// Create axios instance with base configuration
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    config.headers["ngrok-skip-browser-warning"] = "true";
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Auto logout if 401 response
      // Clear all auth-related items
      const itemsToRemove = [
        "token",
        "isAuthenticated",
        "userId",
        "userRole",
        "userName",
        "userEmail",
        "companyId",
      ];

      itemsToRemove.forEach((item) => localStorage.removeItem(item));

      // Redirect to login
      window.location.href = "/login";
    }
    return Promise.reject(error.response?.data || error);
  }
);

// Generic API methods
export const apiService = {
  // GET request
  get: (url, config = {}) => api.get(url, config),

  // POST request
  post: (url, data, config = {}) => api.post(url, data, config),

  // PUT request
  put: (url, data, config = {}) => api.put(url, data, config),

  // PATCH request
  patch: (url, data, config = {}) => api.patch(url, data, config),

  // DELETE request
  delete: (url, config = {}) => api.delete(url, config),

  // File upload
  upload: (url, formData, config = {}) =>
    api.post(url, formData, {
      ...config,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }),
};

export default api;
